import React from "react"
import { AppSelectionBar, AppSelectionBarMenu } from "@components"
import { useMultipleUsers } from "Pages/Admin/Users/@hooks"
import { USER_MULTI_OPTIONS } from "Pages/Admin/Users/@constans"

export default function MultipleUserSelect({ selectedData, setSelectedRows }) {

	const { handleOpenModal } = useMultipleUsers(selectedData, setSelectedRows)

	return <AppSelectionBar count={selectedData?.length || 0} onClear={() => setSelectedRows([])}>
		<AppSelectionBarMenu icon="pen-to-square" label="Edit" items={[
			{ icon: 'arrow-right-to-city', label: 'Offices', onClick: () => handleOpenModal(USER_MULTI_OPTIONS.OFFICE) },
			{ icon: 'globe-pointer', label: 'Sites', onClick: () => handleOpenModal(USER_MULTI_OPTIONS.SITE) },
			{ icon: 'user-tie', label: 'Masters', onClick: () => handleOpenModal(USER_MULTI_OPTIONS.MASTERS) },
		]}/>
	</AppSelectionBar>
}